import React from "react";
import { ActionText, ActionTextCollapsed } from "../ActionText/ActionText";

import { ActionProps, ActionCollapsedProps } from "../_ActionProps";

type ActionDateProps = ActionProps<string> & {
  defaultValue: string;
};
export const ActionDate = (props: ActionDateProps) => (
  <ActionText
    onInputSuccess={props.onInputSuccess}
    onInputFailure={props.onInputFailure}
    value={props.value || props.defaultValue}
    label={props.label}
    regexp="^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
  />
);

export const ActionDateCollapsed = (props: ActionCollapsedProps<string>) => (
  <ActionTextCollapsed {...props} />
);
